import { CardType, getCardByName } from "@/Cards";
import { iso8601ToDate } from "@/utils/iso8601ToDate";

export interface CardDomain {
  id: number;
  name: string;
  cardType: CardType;
  image: string;
}

export interface CardOfTheDayDomain {
  id: number;
  name: string;
  description: string;
  card: CardDomain | null;
  image: string | null;
  resetDate: Date | null;
}

export interface CardOfTheDayDb {
  id: number;
  name: string;
  image: string | null;
  description: string;
  cardTypeName: string;
  resetDate: string;
}

export const mapCardOfTheDayDomainToDb = (
  cardOfTheDay: CardOfTheDayDomain
): CardOfTheDayDb => {
  return {
    id: cardOfTheDay.id,
    name: cardOfTheDay.name,
    image: cardOfTheDay.image ?? null,
    description: cardOfTheDay.description,
    cardTypeName: cardOfTheDay.card?.cardType.toString() ?? "",
    resetDate: cardOfTheDay.resetDate?.toISOString() ?? "",
  };
};

export const mapCardOfTheDayDbToDomain = (
  cardOfTheDay: CardOfTheDayDb
): CardOfTheDayDomain => {
  return {
    id: cardOfTheDay.id,
    name: cardOfTheDay.name,
    description: cardOfTheDay.description,
    card: getCardByName(cardOfTheDay.cardTypeName),
    image: cardOfTheDay.image ?? null,
    resetDate: iso8601ToDate(cardOfTheDay.resetDate),
  };
};

export interface CardOfTheDayDto {
  id: number;
  name: string;
  description: string;
}

export const mapCardOfTheDayDtoToDomain = (
  dto: CardOfTheDayDto,
  resetDate: string | null
): CardOfTheDayDomain => {
  const card = getCardByName(dto.name);

  return {
    id: dto.id,
    name: card?.name ?? "",
    description: dto.description,
    card: card ?? null,
    image: card?.image ?? null,
    resetDate: iso8601ToDate(resetDate),
  };
};
